import { render, staticRenderFns } from "./OperationAuth.vue?vue&type=template&id=2a52c824&scoped=true"
import script from "./OperationAuth.vue?vue&type=script&lang=ts"
export * from "./OperationAuth.vue?vue&type=script&lang=ts"
import style0 from "./OperationAuth.vue?vue&type=style&index=0&id=2a52c824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a52c824",
  null
  
)

export default component.exports